var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.33 1.25H1.67A1.25 1.25 0 0 0 .42 2.5v11.3A1.22 1.22 0 0 0 1.67 15h2.5v3.33a.4.4 0 0 0 .22.37.4.4 0 0 0 .43 0l5.31-3.7h8.2a1.25 1.25 0 0 0 1.25-1.25V2.5a1.25 1.25 0 0 0-1.25-1.25ZM4.38 10A.63.63 0 0 1 5 9.37h10a.63.63 0 0 1 0 1.26H5a.63.63 0 0 1-.63-.63ZM15 6.87H5a.63.63 0 0 1 0-1.25h10a.63.63 0 0 1 0 1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3cccf71f.svg";
export { ForwardRef as ReactComponent };